import { render, staticRenderFns } from "./RegulatoryThresholds.vue?vue&type=template&id=eeedbd08&scoped=true"
import script from "./RegulatoryThresholds.vue?vue&type=script&lang=js"
export * from "./RegulatoryThresholds.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryThresholds.vue?vue&type=style&index=0&id=eeedbd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeedbd08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
